<template>
  <div class="navbar" :class="{ mobile: isMobile }">
    <div class="initials nav-link" @click="changeNav('Home')">
      <h3><span class="blue">B.</span><span class="purple">P.</span></h3>
    </div>

    <!-- Hamburger (mobile only) -->
    <div class="hamburger" v-if="isMobile" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <ul class="center-nav" :class="menuOpen ? 'open mobile' : ''">
      <a class="nav-link" :class="selectedNav == 'Home' ? 'selected-link' : ''" @click="changeNav('Home')">
        <font-awesome-icon class="nav-svg" :icon="['fab', 'fort-awesome']"></font-awesome-icon>
        <p class="nav-text">Home</p>
      </a>
      <a class="nav-link" :class="selectedNav == 'About' ? 'selected-link' : ''" @click="changeNav('About')">
        <font-awesome-icon class="nav-svg" :icon="['fab', 'themeco']"></font-awesome-icon>
        <p class="nav-text">About</p>
      </a>
      <a class="nav-link" :class="selectedNav == 'Skills' ? 'selected-link' : ''" @click="changeNav('Skills')">
        <font-awesome-icon class="nav-svg" icon="code"></font-awesome-icon>
        <p class="nav-text">Skills</p>
      </a>
      <a class="nav-link" :class="selectedNav == 'Contact' ? 'selected-link' : ''" @click="changeNav('Contact')">
        <font-awesome-icon class="nav-svg" :icon="['fab', 'weixin']"></font-awesome-icon>
        <p class="nav-text">Contact</p>
      </a>
    </ul>
    <ul class="bottom-nav" v-if="!isMobile">
      <a class="nav-link" href="https://github.com/Rycebal" target="_blank">
        <font-awesome-icon :icon="['fab', 'github']"></font-awesome-icon>
        <!-- <p>Github</p> -->
      </a>
      <a class="nav-link" href="https://www.linkedin.com/in/brycepalmerdev/" target="_blank">
        <font-awesome-icon :icon="['fab', 'linkedin']"></font-awesome-icon>
        <!-- <p>Linked In</p> -->
      </a>
      <a class="nav-link" href="mailto:brympal@gmail.com">
        <font-awesome-icon  icon="paper-plane"></font-awesome-icon> <!-- icon="paper-plane" -->
      </a>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Navbar',
  props: ['nav'],
  data() {
    return {
      selectedNav: '',
      isMobile: false,
      menuOpen: false,
    };
  },
  mounted() {
    this.checkScreen();
    window.addEventListener('resize', this.checkScreen);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreen);
  },
  watch: { 
    nav: function (val) {
      if (val) {
        this.selectedNav = val;
      } else {
        this.selectedNav = 'Home'
      }
    }
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) this.menuOpen = false;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      console.log('menu toggled: ', this.menuOpen);
    },
    changeNav(loc) {
      this.selectedNav = loc;
      this.$emit('navChange', loc);
      if (this.isMobile) this.menuOpen = false;
    }
  },
};
</script>
<style scoped>
.navbar{
  position: fixed;
  top: 0;
  z-index: 10;
  display: flex;
  height: 100vh;
  width: 65px;
  left: 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #161616;
  color: #fff;
}
.initials {
  height: 65px;
  width: 65px;
  background-color: #000;
  h3 {
    text-align: center;
    margin-top: 25%;
    margin-bottom: 25%;
  }
}
.center-nav {
  display: flex;
  min-width: 100%;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  height: 40%;
  .nav-link:hover {
    color: #00eeff;
  }
}
.blue {
  color: #00eeff;
}
.purple {
    color: #ff00ee;
}
.nav-link {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  font-size: 1.5rem;
  color: #4d4d4e;
  text-decoration: none;
  min-width: 100%;
  min-height: 24px;
  align-items: center;
  cursor: pointer;
  .nav-text, .nav-svg {
    transition: all .4s ease-in-out;
  }
  .nav-text {
    position: absolute;
    padding: 0;
    margin-top: 10px;
    opacity: 0 !important;
    height: 24px;
  }
  .nav-svg {
    opacity: 1 !important;
  }
}
.nav-link:hover {
  .nav-text, .nav-svg {
    transition: all .4s ease-in-out;
  }
  .nav-text {
    opacity: 1 !important;
    color: #00eeff;
  }
  .nav-svg {
    opacity: 0 !important;
  }
}
p {
  font-size: .7rem;
}
.bottom-nav {
  display: flex;
  min-width: 100%;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 20px;
  height: 20%;
  .nav-link {
    transition: all .4s ease-in-out;
  }
  .nav-link:hover {
    color: #ff00ee;
    transition: all .4s ease-in-out;
  }
}
.selected-link {
  color: #00eeff;
}

/* MOBILE MODE */
.navbar.mobile {
  z-index: 12;
  flex-direction: row;
  height: 65px;
  width: 100vw;
  left: 0;
}

.hamburger {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  justify-content: end;
  position: absolute;
  top: 20px;
  right: 20px;

  span {
    width: 25px;
    height: 4px;
    margin-bottom: 6px;
    background: #fff;
  }
}

.center-nav.mobile {
  position: fixed;
  top: 65px;
  left: 0;
  width: 100%;
  height: calc(100vh - 65px);
  background: #161616;
  transform: translateY(-100%);
  transition: transform 0.3s ease;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 2rem;
}

.center-nav.open {
  transform: translateY(0);
}

.mobile {
  .initials.nav-link {
    padding-left: 10px;
    justify-content: start;
  }
}

.mobile {
  .center-nav .nav-link {
    min-height: 50px;
    font-size: 3rem;
    margin-bottom: 50px;
  }

  .nav-text {
    opacity: 1 !important;
    position: static !important;
    margin-left: 10px;
    font-size: 1.2rem;
  }
}

.nav-svg.mobile {
  opacity: 1 !important;
}

</style>
